import * as React from 'react'
import { Slot } from 'radix-ui'

import { cn } from '@/lib/utils'
import styles from './Button.module.scss'

export type ButtonVariant = 'default' | 'outline' | 'ghost'
export type ButtonSize = 'default' | 'xs' | 'sm' | 'lg'

const sizeClass: Record<ButtonSize, string | undefined> = {
  default: undefined,
  xs: styles.xs,
  sm: styles.sm,
  lg: styles.lg,
}

function buttonVariants({
  variant = 'default',
  size = 'default',
  className,
}: {
  variant?: ButtonVariant
  size?: ButtonSize
  className?: string
} = {}) {
  return cn(styles.button, styles[variant], sizeClass[size], className)
}

function Button({
  className,
  variant = 'default',
  size = 'default',
  asChild = false,
  ...props
}: React.ComponentProps<'button'> & {
  variant?: ButtonVariant
  size?: ButtonSize
  asChild?: boolean
}) {
  const Comp = asChild ? Slot.Root : 'button'

  return (
    <Comp
      data-slot="button"
      data-variant={variant}
      data-size={size}
      className={buttonVariants({ variant, size, className })}
      {...props}
    />
  )
}

export { Button, buttonVariants }
